(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["auvra-announcement"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-auvra-countdown]').forEach(function(el){
    var hours = parseInt(el.getAttribute('data-duration-hours'),10) || 72;
    var key = 'auvra_countdown_end';
    var end = parseInt(localStorage.getItem(key),10);
    var now = Date.now();
    if(!end || end < now){ end = now + hours*3600*1000; localStorage.setItem(key, end); }
    var d=el.querySelector('[data-days]'), h=el.querySelector('[data-hours]'), m=el.querySelector('[data-mins]'), s=el.querySelector('[data-secs]');
    function pad(n){ return (n<10?'0':'')+n; }
    function tick(){
      var diff = Math.max(0, end - Date.now());
      var sec = Math.floor(diff/1000);
      d.textContent = pad(Math.floor(sec/86400));
      h.textContent = pad(Math.floor((sec%86400)/3600));
      m.textContent = pad(Math.floor((sec%3600)/60));
      s.textContent = pad(sec%60);
      if(diff===0){ end = Date.now()+hours*3600*1000; localStorage.setItem(key,end); }
    }
    tick(); setInterval(tick,1000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auvra-buy-box"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* Gallery: thumbnail click swaps the stage image */
  document.querySelectorAll('.auvra-buybox').forEach(function(box){
    var main = box.querySelector('.auvra-buybox__mainimg');
    box.querySelectorAll('.auvra-buybox__thumb').forEach(function(t){
      t.addEventListener('click', function(){
        if(main && t.getAttribute('data-full')){ main.src = t.getAttribute('data-full'); }
        box.querySelectorAll('.auvra-buybox__thumb').forEach(function(o){ o.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  });

  /* CTA wiring:
     - "Shop Up To 70% Off Now" is the ONLY button that scrolls to #buy-box.
     - Every other "Shop..." CTA (e.g. the "Shop Now" bestseller card) goes to the product page. */
  var target = document.getElementById('buy-box');
  if(!target) return;
  function productUrl(){
    /* Always render the custom template; the product 'as' is assigned the GemPages
       template by default, so `view=kyles-test-template` is required to show this design. */
    var params = new URLSearchParams(location.search);
    var q = 'view=kyles-test-template';
    var pt = params.get('preview_theme_id');
    if(pt){ q += '&preview_theme_id=' + pt; }
    return '/products/as?' + q;
  }
  function bind(){
    document.querySelectorAll('a, button').forEach(function(el){
      if(el.dataset.buyboxBound) return;
      var txt = (el.innerText || '').trim().toLowerCase();
      if(!/^shop\b/.test(txt)) return;
      var isScroll = /70%\s*off/.test(txt); /* ONLY "Shop Up To 70% Off Now" scrolls */
      /* Clone the node to strip GemPages' own click/scroll listeners, then rebind ours. */
      var clone = el.cloneNode(true);
      clone.dataset.buyboxBound = '1';
      if(isScroll){
        if(clone.tagName === 'A') clone.setAttribute('href', '#buy-box');
        clone.addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();
          target.scrollIntoView({behavior:'smooth', block:'start'});
          setTimeout(function(){
            if(Math.abs(target.getBoundingClientRect().top) > 300){ target.scrollIntoView({block:'start'}); }
          }, 1000);
        });
      } else {
        var url = productUrl(); /* every other "Shop..." CTA -> product detail page */
        if(clone.tagName === 'A'){ clone.setAttribute('href', url); clone.removeAttribute('target'); }
        clone.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); window.location.href = url; });
      }
      if(el.parentNode) el.parentNode.replaceChild(clone, el);
    });
  }
  bind();
  /* GemPages hydrates late; rebind a few times */
  var tries = 0;
  var iv = setInterval(function(){ bind(); if(++tries > 10) clearInterval(iv); }, 800);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auvra-fx"] && !Shopify.designMode) return;
  try {
    
(function(){
  function ready(fn){ if(document.readyState!=='loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
  ready(function(){
    /* ---------- GALLERY: click/hover thumbnails to swap, auto-cycle ---------- */
    document.querySelectorAll('.auvra-hero').forEach(function(root){
      var main = root.querySelector('.auvra-hero__mainimg');
      var thumbs = [].slice.call(root.querySelectorAll('img.auvra-hero__thumb'));
      if(!main || thumbs.length < 2) return;
      var idx = 0, manual = false, timer = null;
      function show(i){
        idx = (i + thumbs.length) % thumbs.length;
        thumbs.forEach(function(t){ t.classList.remove('is-active'); });
        var t = thumbs[idx];
        t.classList.add('is-active');
        var src = (t.currentSrc || t.src || '').replace(/width=\d+/, 'width=1000');
        if(src){ main.src = src; }
      }
      thumbs.forEach(function(t, i){
        t.setAttribute('tabindex','0');
        t.addEventListener('click', function(){ manual = true; stop(); show(i); });
        t.addEventListener('mouseenter', function(){ show(i); });
        t.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); manual=true; stop(); show(i); } });
      });
      main.addEventListener('click', function(){ manual = true; stop(); show(idx + 1); });
      function stop(){ if(timer){ clearInterval(timer); timer = null; } }
      function start(){ if(!manual && !timer){ timer = setInterval(function(){ show(idx + 1); }, 4000); } }
      var gallery = root.querySelector('.auvra-hero__gallery');
      if(gallery){ gallery.addEventListener('mouseenter', stop); gallery.addEventListener('mouseleave', start); }
      show(0); start();
    });

    /* ---------- ASK widget: tab switching + clickable chips ---------- */
    document.querySelectorAll('.auvra-ask').forEach(function(ask){
      var tabs = [].slice.call(ask.querySelectorAll('.auvra-ask__tab'));
      tabs.forEach(function(tab){
        tab.addEventListener('click', function(){
          tabs.forEach(function(t){ t.classList.remove('is-active'); });
          tab.classList.add('is-active');
        });
      });
      var input = ask.querySelector('.auvra-ask__bar input');
      ask.querySelectorAll('.auvra-ask__chips span').forEach(function(chip){
        chip.setAttribute('tabindex','0');
        chip.addEventListener('click', function(){
          if(input){ input.value = chip.textContent.replace(/^[^A-Za-z0-9]+/, '').trim(); input.focus(); }
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auvra-sticky-bar"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-auvra-sticky]').forEach(function(bar){
    var sel = bar.querySelector('[data-auvra-select]');
    var trigger = bar.querySelector('[data-auvra-trigger]');
    var menu = bar.querySelector('[data-auvra-menu]');
    var nameEl = bar.querySelector('[data-plan-name]');
    var subEl = bar.querySelector('[data-plan-sub]');
    var cta = bar.querySelector('[data-auvra-cta]');
    var form = bar.querySelector('form');
    var qty = form ? form.querySelector('[data-qty]') : null;
    var sp = form ? form.querySelector('[data-sp]') : null;

    trigger.addEventListener('click', function(e){
      e.stopPropagation();
      var open = sel.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function(){ sel.classList.remove('is-open'); trigger.setAttribute('aria-expanded','false'); });

    menu.querySelectorAll('[data-name]').forEach(function(opt){
      opt.addEventListener('click', function(){
        menu.querySelectorAll('[data-name]').forEach(function(o){ o.classList.remove('is-active'); });
        opt.classList.add('is-active');
        nameEl.innerHTML = opt.getAttribute('data-name');
        subEl.textContent = opt.getAttribute('data-sub');
        cta.innerHTML = opt.getAttribute('data-cta');
        if(qty){ qty.value = opt.getAttribute('data-qty') || '1'; }
        if(sp){
          var planId = opt.getAttribute('data-sp') || '';
          if(planId){ sp.value = planId; sp.disabled = false; }
          else { sp.value = ''; sp.disabled = true; }
        }
        sel.classList.remove('is-open');
        trigger.setAttribute('aria-expanded','false');
      });
    });

    var anchor = document.querySelector('.auvra-plans') || document.querySelector('.auvra-hero');
    function toggle(){
      var show;
      if(anchor){ show = anchor.getBoundingClientRect().bottom < 60; }
      else { show = window.scrollY > 640; }
      bar.classList.toggle('is-visible', show);
    }
    if('IntersectionObserver' in window && anchor){
      var io = new IntersectionObserver(function(entries){
        bar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }, { rootMargin: '-60px 0px 0px 0px', threshold: 0 });
      io.observe(anchor);
    }
    window.addEventListener('scroll', toggle, { passive:true });
    toggle();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auvra-theme-switcher"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* Carry the theme preview param across navigations so the draft theme stays in preview. */
  function withPreview(url){
    var pt = new URLSearchParams(location.search).get('preview_theme_id');
    if(!pt) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'preview_theme_id=' + pt;
  }
  /* Which source link, if any, matches the page we're on. Prefers an exact ?view= match. */
  function currentLink(links){
    var path = decodeURIComponent(location.pathname);
    var view = new URLSearchParams(location.search).get('view');
    var best = null;
    for (var i=0;i<links.length;i++){
      var url  = links[i].getAttribute('href');
      var base = url.split('?')[0];
      var pv   = (url.split('view=')[1] || '');
      if (path.indexOf(base) === 0){ if (view === pv) return links[i]; if (!best) best = links[i]; }
    }
    return best;
  }
  function build(src){
    var srcLinks = src.querySelectorAll('a');
    var cur = currentLink(srcLinks);

    var wrap = document.createElement('div');
    wrap.className = 'rev-switch';
    wrap.id = 'rev-switch';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rev-switch__btn';
    btn.setAttribute('aria-haspopup','true');
    btn.setAttribute('aria-expanded','false');
    var label = document.createElement('span');
    label.className = 'rev-switch__label';
    /* Show the current product when we're on one; otherwise name what the control does. */
    label.textContent = cur ? cur.textContent.trim() : 'Choose a product';
    btn.appendChild(label);
    btn.insertAdjacentHTML('beforeend',
      '<svg class="rev-switch__chev" viewBox="0 0 12 8" fill="none" aria-hidden="true">' +
      '<path d="M1 1.5 6 6.5l5-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>');

    var menu = document.createElement('div');
    menu.className = 'rev-switch__menu';
    menu.setAttribute('role','menu');
    menu.hidden = true;
    for (var i=0;i<srcLinks.length;i++){
      var a = srcLinks[i];
      var item = document.createElement('a');
      item.className = 'rev-switch__item' + (a === cur ? ' is-current' : '');
      /* A real href: clicking always lands on that product detail page — including the
         one already displayed, which the old <select> could never reach (no change event). */
      item.href = withPreview(a.getAttribute('href'));
      item.textContent = a.textContent.trim();
      item.setAttribute('role','menuitem');
      menu.appendChild(item);
    }

    function place(){
      var r = btn.getBoundingClientRect();
      menu.style.top = (r.bottom + 8) + 'px';
      menu.hidden = false;                 /* must be rendered to measure its width */
      /* Align under the button, nudged left only if it would overflow the right edge.
         Guard the viewport width: some embedded/preview browsers report 0 mid-layout,
         which would otherwise clamp every menu to the far left of the screen. */
      var vw = document.documentElement.clientWidth || window.innerWidth || 0;
      var left = r.left;
      if (vw > menu.offsetWidth + 24) left = Math.max(12, Math.min(left, vw - menu.offsetWidth - 12));
      menu.style.left = Math.round(left) + 'px';
    }
    function isOpen(){ return btn.getAttribute('aria-expanded') === 'true'; }
    function open(){ place(); btn.setAttribute('aria-expanded','true'); }
    function close(){ menu.hidden = true; btn.setAttribute('aria-expanded','false'); }

    btn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); isOpen() ? close() : open(); });
    document.addEventListener('click', function(e){ if(isOpen() && !wrap.contains(e.target)) close(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && isOpen()){ close(); btn.focus(); } });
    window.addEventListener('scroll', function(){ if(isOpen()) close(); }, {passive:true});
    window.addEventListener('resize', function(){ if(isOpen()) place(); });

    wrap.appendChild(btn);
    wrap.appendChild(menu);
    return wrap;
  }
  function ensure(){
    var src = document.getElementById('rev-switch-source');
    if(!src) return;
    var host = document.querySelector('.header__column--right')
            || document.querySelector('.header__columns')
            || document.querySelector('.header') || document.querySelector('header');
    if(!host) return;
    var live = document.getElementById('rev-switch');
    if(live && host.contains(live)) return; /* still present — leave it (and any open menu) alone */
    if(live && live.parentNode) live.parentNode.removeChild(live);
    host.insertBefore(build(src), host.firstChild);
  }
  function init(){
    ensure();
    /* keep re-asserting the header dropdown through the header's hydration window */
    var n = 0, iv = setInterval(function(){ ensure(); if (++n > 30) clearInterval(iv); }, 400);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rev-home-card"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* keep the draft-preview theme when navigating from the home cards */
  var pt = new URLSearchParams(location.search).get('preview_theme_id');
  if(!pt) return;
  document.querySelectorAll('[data-revhc-link]').forEach(function(a){
    var href = a.getAttribute('href'); if(!href || /preview_theme_id=/.test(href)) return;
    a.setAttribute('href', href + (href.indexOf('?')>-1?'&':'?') + 'preview_theme_id=' + pt);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rev-resilia"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('.rev-rz');
  if(!root) return;

  var variantId = parseInt(root.dataset.variant, 10);

  /* Currency style is derived from a Liquid-rendered sample of 100 cents. Parsing
     shop.money_format here would need a double-brace literal, which cannot appear inside
     a section script block — it breaks the block and the whole script is dropped. */
  var sample = root.dataset.moneySample || '$1.00';
  var sym = sample.replace(/[0-9.,\s]/g, '');
  var withDecimals = /[.,]\d\d/.test(sample);
  function money(cents){
    var n = cents / 100;
    return sym + (withDecimals ? n.toFixed(2) : String(Math.round(n)));
  }

  /* ---- gallery ---- */
  var main = root.querySelector('.rev-rz__main');
  root.querySelectorAll('.rev-rz__thumb').forEach(function(t){
    t.addEventListener('click', function(){
      if(main && t.dataset.full) main.src = t.dataset.full;
      root.querySelectorAll('.rev-rz__thumb').forEach(function(o){ o.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });
  var thumbStrip = root.querySelector('[data-rz-thumbs]');
  root.querySelectorAll('[data-rz-tnav]').forEach(function(b){
    b.addEventListener('click', function(){
      if(!thumbStrip) return;
      thumbStrip.scrollBy({ left: 220 * parseInt(b.dataset.rzTnav, 10), behavior:'smooth' });
    });
  });

  /* ---- carousels: arrows + dot sync ---- */
  root.querySelectorAll('[data-rz-scroll]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var key = btn.dataset.rzScroll;
      var track = root.querySelector('[data-rz-track="' + key + '"]');
      if(!track) return;
      var card = track.firstElementChild;
      var step = card ? card.getBoundingClientRect().width + 24 : 280;
      track.scrollBy({ left: step * parseInt(btn.dataset.dir, 10), behavior:'smooth' });
    });
  });
  root.querySelectorAll('[data-rz-dots]').forEach(function(dots){
    var key = dots.dataset.rzDots;
    var track = root.querySelector('[data-rz-track="' + key + '"]');
    if(!track) return;
    var bars = [].slice.call(dots.children);
    track.addEventListener('scroll', function(){
      var max = track.scrollWidth - track.clientWidth;
      var pct = max > 0 ? track.scrollLeft / max : 0;
      var i = Math.min(bars.length - 1, Math.round(pct * (bars.length - 1)));
      bars.forEach(function(b, n){ b.classList.toggle('is-active', n === i); });
    }, {passive:true});
  });

  /* ---- bundle selection.
     Two buy boxes render the same three bundles (hero + stock-up). Selecting in either
     updates both, so the page never shows two different prices at once. ---- */
  var qty = 2;

  function paint(){
    var groups = root.querySelectorAll('[data-rz-bundles]');
    var priceC = 0, wasC = 0, saveC = 0;

    groups.forEach(function(g){
      g.querySelectorAll('[data-rz-bundle]').forEach(function(card){
        var on = parseInt(card.dataset.qty, 10) === qty;
        card.classList.toggle('is-active', on);
        var input = card.querySelector('input');
        if(input) input.checked = on;
        if(on){
          priceC = parseInt(card.dataset.price, 10);
          wasC   = parseInt(card.dataset.was, 10);
          saveC  = parseInt(card.dataset.save, 10);
        }
      });
    });

    root.querySelectorAll('[data-rz-price]').forEach(function(e){ e.textContent = money(priceC); });
    root.querySelectorAll('[data-rz-was]').forEach(function(e){ e.textContent = money(wasC); });
    root.querySelectorAll('[data-rz-save]').forEach(function(e){ e.textContent = money(saveC); });
    root.querySelectorAll('[data-rz-atc-price]').forEach(function(e){ e.textContent = money(priceC); });
    root.querySelectorAll('[data-rz-atc-was]').forEach(function(e){ e.textContent = money(wasC); });

    /* gift tray: qty 1 unlocks nothing, 2 unlocks shipping + jar, 3 unlocks all three */
    root.querySelectorAll('[data-rz-gift]').forEach(function(g){
      var slot = parseInt(g.dataset.rzGift, 10);
      var unlocked = (qty >= 2 && slot <= 2) || (qty >= 3);
      g.classList.toggle('is-unlocked', unlocked);
      g.classList.toggle('is-locked', !unlocked);
      var lockLabel = g.querySelector('.rev-rz__gift-locked');
      if(lockLabel) lockLabel.textContent = unlocked ? 'Unlocked' : 'Locked';
    });
  }

  root.querySelectorAll('[data-rz-bundle]').forEach(function(card){
    card.addEventListener('click', function(){
      qty = parseInt(card.dataset.qty, 10) || 1;
      paint();
    });
  });

  /* ---- add to cart (JS API, so the Kaching apps can't hijack a form) ---- */
  root.querySelectorAll('[data-rz-atc]').forEach(function(btn){
    btn.addEventListener('click', function(){
      if(!variantId) return;
      var label = btn.querySelector('.rev-rz__atc-label');
      var restore = label ? label.textContent : '';
      btn.disabled = true;
      if(label) label.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
      .then(function(r){ return r.json(); })
      .then(function(){ window.themeGoToCheckout(); })
      .catch(function(){ btn.disabled = false; if(label) label.textContent = restore; });
    });
  });

  paint();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rev-retail"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('.rev-rt');
  if(!root) return;

  /* ---- gallery: thumb click swaps the stage image ---- */
  var main = root.querySelector('.rev-rt__main');
  root.querySelectorAll('.rev-rt__thumb').forEach(function(t){
    t.addEventListener('click', function(){
      if(main && t.dataset.full) main.src = t.dataset.full;
      root.querySelectorAll('.rev-rt__thumb').forEach(function(o){ o.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  /* ---- show more images ---- */
  var showmore = root.querySelector('[data-rt-showmore]');
  if(showmore){
    showmore.addEventListener('click', function(){
      root.querySelectorAll('.rev-rt__more-cell.is-hidden').forEach(function(c){ c.classList.remove('is-hidden'); });
      showmore.remove();
    });
  }

  /* ---- one-time vs subscribe.
     Presentational only: no selling plan exists on this store, so both choices add the
     same one-time variant. Swaps the headline price and the button label. ---- */
  var opts  = root.querySelectorAll('.rev-rt__opt');
  var label = root.querySelector('[data-rt-atc-label]');
  var price = root.querySelector('[data-rt-price]');
  var basePrice = price ? price.textContent : '';
  var subPrice  = (function(){
    var el = root.querySelector('.rev-rt__opt--sub .rev-rt__opt-price');
    return el ? el.textContent.trim() : basePrice;
  })();
  opts.forEach(function(opt){
    opt.addEventListener('click', function(){
      opts.forEach(function(o){ o.classList.remove('is-active'); });
      opt.classList.add('is-active');
      var input = opt.querySelector('input'); if(input) input.checked = true;
      var isSub = opt.dataset.rtMode === 'sub';
      if(label) label.textContent = isSub ? 'ADD SUBSCRIPTION TO CART' : 'ADD TO CART';
      if(price) price.textContent = isSub ? subPrice : basePrice;
    });
  });

  /* ---- carousel arrows ---- */
  root.querySelectorAll('[data-rt-scroll]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var track = root.querySelector('[data-rt-track="' + btn.dataset.rtScroll + '"]');
      if(!track) return;
      var card = track.querySelector('.rev-rt__card');
      var step = card ? card.getBoundingClientRect().width : 260;
      track.scrollBy({ left: step * parseInt(btn.dataset.dir, 10) * 2, behavior:'smooth' });
    });
  });

  /* ---- cart adds via the JS API, so the Kaching apps can't hijack a form ---- */
  var qtySel = root.querySelector('[data-rt-qty]');
  root.querySelectorAll('[data-rt-atc]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var id = parseInt(btn.dataset.variant, 10);
      if(!id) return;
      var isMain = btn.classList.contains('rev-rt__atc');
      var qty = (isMain && qtySel) ? parseInt(qtySel.value, 10) || 1 : 1;
      var restore = btn.innerHTML;
      btn.disabled = true;
      fetch('/cart/add.js', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ id:id, quantity:qty })
      })
      .then(function(r){ return r.json(); })
      .then(function(){ window.themeGoToCheckout(); })
      .catch(function(){ btn.disabled = false; btn.innerHTML = restore; });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rev-vitapeak"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.rev-vp').forEach(function(root){
    var main = root.querySelector('.rev-vp__main');
    root.querySelectorAll('.rev-vp__thumb').forEach(function(t){
      t.addEventListener('click', function(){
        if(main && t.dataset.full) main.src = t.dataset.full;
        root.querySelectorAll('.rev-vp__thumb').forEach(function(o){ o.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
